export default __webpack_public_path__ + "fonts/color_process_bg.7007a09377ed9a0e1c36fa06195ab45a.png";